import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { AppStackParamList } from '@src/navigation/types'
import { TutorialSensorKind } from '@src/screens/Tutorials/models/tutorials.types'
import { useTutorialNavigation } from '@src/screens/Tutorials/hooks'
import { SensorModel } from '@src/types'
import { useShowPurchasedSteloSetupPopup } from './useShowPurchasedSteloSetupPopup'
import { useShowSteloIntegrationPopupForDexcomUsers } from './useShowSteloIntegrationPopupForDexcomUsers'

export const useShowSteloSetupPopupOrchestrator = () => {
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  const showSteloIntegrationPopupForDexcomUsers = useShowSteloIntegrationPopupForDexcomUsers()
  const showPurchasedSteloSetupPopup = useShowPurchasedSteloSetupPopup()
  const navigateToSteloTutorial = useTutorialNavigation(TutorialSensorKind.DexcomSteloRealtime)

  // We should always show the Stelo integration popup for Dexcom users if applicable
  const shouldShow = showSteloIntegrationPopupForDexcomUsers || showPurchasedSteloSetupPopup

  const getPopupConfig = () => {
    if (showSteloIntegrationPopupForDexcomUsers) {
      return {
        onPress: () => {
          return navigation.navigate('DexcomSensorSettings', {
            sensorModel: SensorModel.DexcomStelo,
          })
        },
        headlineText: 'Connect your Stelo account',
        bodyText: 'Tap to link your accounts and see your glucose data.',
      }
    }

    if (showPurchasedSteloSetupPopup) {
      return {
        onPress: navigateToSteloTutorial,
        headlineText: 'Received your Stelo shipment?',
        bodyText: 'Tap to start your setup.',
      }
    }

    return { onPress: () => {}, headlineText: '', bodyText: '' }
  }

  const { onPress, headlineText, bodyText } = getPopupConfig()

  return { onPress, headlineText, bodyText, shouldShow }
}
